import React from 'react';
import Button from './Button';
import './commonStyle.css';

/**
 * ConfirmModal — house-styled confirm / cancel dialog. Sibling of AlertModal: it reuses the exact
 * same overlay + card (common-modal-overlay / common-alert) so a confirmation matches the app's
 * existing modal instead of a native window.confirm. Adds a Cancel button and a confirm/cancel
 * result. Usually driven imperatively via setup/confirmService (askConfirm), not rendered directly.
 *
 * Props:
 * - show: boolean
 * - title, message: strings
 * - confirmLabel (default 'OK'), cancelLabel (default 'Cancel')
 * - danger: boolean — the action is destructive; styles the confirm button red + the title as a warning
 * - eviewMode: boolean — green theme (parity with AlertModal)
 * - onConfirm, onCancel: callbacks
 */
const ConfirmModal = ({
  show, title, message, confirmLabel, cancelLabel, danger, eviewMode, onConfirm, onCancel,
}) => {
  if (!show) return null;
  return (
    // backdrop click = cancel (never a destructive default)
    <div className="common-modal-overlay" onClick={onCancel}>
      <div
        className={'common-alert' + (eviewMode ? ' eview-mode' : '')}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <p className={'common-alert__title' + (danger ? ' common-alert__title--warning' : '')}>
          {title || 'Confirm'}
        </p>
        <p className="common-alert__message">{message}</p>
        <div className="common-alert__buttons">
          <Button onClick={onCancel} buttonText={cancelLabel || 'Cancel'} className="modal-btn--cancel" />
          <Button
            onClick={onConfirm}
            buttonText={confirmLabel || 'OK'}
            className={danger ? 'modal-btn--danger' : 'modal-btn--primary'}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
